exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shift {\n    /* width: 90%;\n    height: 10px; */\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.shift>div {\n    float: left;\n    width: 25% !important;\n    height: 2px !important;\n    padding-left: 3%;\n    margin-left: 5px;\n}\n\n.shift>div.full {\n    background-color: var(--primary);\n}\n\n.shift>div.quarter:first-child {\n    background: linear-gradient(to right, var(--primary) 0%, var(--primary) 25%, var(--disabled) 26%);\n}\n\n.shift>div.quarter:first-child {\n    background: linear-gradient(to right, red 0%, red 25%, var(--disabled) 26%);\n}\n\n.shift>div.half {\n    background: linear-gradient(to right, var(--primary) 0%, var(--primary) 50%, var(--disabled) 51%);\n}\n\n.shift>div.half:first-child {\n    background: linear-gradient(to right, red 0%, red 50%, var(--disabled) 51%);\n}\n\n.shift .three-quarter {\n    background: linear-gradient(to right, var(--primary) 0%, var(--primary) 75%, var(--disabled) 76%);\n}\n\n.shift .three-quarter:first-child {\n    background: linear-gradient(to right, red 0%, red 75%, var(--disabled) 76%);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/shift-count/shift-count.component.css
// module id = ../../../../../src/app/shared/components/shift-count/shift-count.component.css
// module chunks = main